import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

// 启用插件
dayjs.extend(utc);
dayjs.extend(timezone);

// 统一设定前端展示时区：北京时间
export const DISPLAY_TIMEZONE = 'Asia/Shanghai';
dayjs.tz.setDefault(DISPLAY_TIMEZONE);

/**
 * 后端 UTC 时间字符串 → 北京时间字符串
 * @param {string|Date} value  ISO8601 (带 Z) 或 Date
 * @param {string} format     dayjs format
 */
export function formatToBJ(
    value,
    format = 'YYYY-MM-DD HH:mm:ss',
) {
    if (!value) return '';
    return dayjs.utc(value).tz(DISPLAY_TIMEZONE).format(format);
}

/**
 * 后端 UTC 时间 → Date（给 el-date-picker 用）
 */
export function utcToDate(value) {
    if (!value) return null;
    return dayjs.utc(value).toDate();
}

/**
 * Date / 本地时间 → UTC ISO 字符串（提交给后端）
 */
export function dateToUtcISOString(value) {
    if (!value) return null;
    return dayjs(value).utc().toISOString();
}

/**
 * 是否过期（基于 UTC 比较，避免时区问题）
 */
export function isExpired(utcTime) {
    if (!utcTime) return false;
    return dayjs.utc().isAfter(dayjs.utc(utcTime));
}

/**
 * 计算与现在的时间差（秒）
 */
export function diffFromNow(utcTime, unit = 'second') {
    if (!utcTime) return 0;
    return dayjs.utc().diff(dayjs.utc(utcTime), unit);
}

/**
 * 当前 UTC 时间（提交给后端用）
 */
export function nowUtcISOString() {
    return dayjs.utc().toISOString();
}

export default dayjs;
